import { borderRadius, color, fontFamily, fontSize, space } from '@core-ds/primitives';
import { string } from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';

const Container = styled.div`
   border-radius: ${borderRadius.sm};
   margin: ${space[1]} 0;
   padding: 0 ${space[1]};
   line-height: 17px;
   min-height: 17px;
   color: ${color.gray[800]};
   background-color: ${color.gray[400]};
   transition: background-color 0.1s;
   font-family: ${fontFamily.monoSystem};
   font-weight: bold;
   font-size: ${fontSize.sm};
   display: flex;
   align-items: center;

   :hover {
      background-color: ${color.white};
   }
`;

const LanguageButton = ({ isoCode }) => (
   <Container id="js-iso-language-dropdown-button">{isoCode}</Container>
);

LanguageButton.propTypes = {
   isoCode: string.isRequired,
};

export default LanguageButton;
